import { AxiosError } from 'axios'

/**
 * Returns true when the given error is an HTTP 404 response.
 * Tolerant of both AxiosError shapes and plain `{ status }` / `{ response: { status } }` payloads.
 */
export function isNotFoundError(error: unknown): boolean {
  if (!error) return false
  if (error instanceof AxiosError && error.response?.status === 404) return true
  const status = (error as { status?: number })?.status
    ?? (error as { response?: { status?: number } })?.response?.status

  return status === 404
}
